import(/* webpackMode: "eager", webpackExports: ["Skeleton"] */ "/vercel/path0/components/ui/Skeleton.tsx");
